import { useMinimizedModalsContext } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { MinimizedModalsTrayItem } from '../MinimizedModalsTrayItem'

import { QA_NAME_MINIMIZED_MODALS_TRAY } from './MinimizedModalsTray.constants'

import * as styles from './MinimizedModalsTray.module.css'

function MinimizedModalsTray() {
  const { entriesValues } = useMinimizedModalsContext()

  const qaProps = getQaSelector({ value: QA_NAME_MINIMIZED_MODALS_TRAY })

  return entriesValues.length > 0 ? (
    <div {...qaProps} className={styles.tray}>
      {entriesValues.map(({ key, ...entry }) => (
        <MinimizedModalsTrayItem {...entry} key={key} />
      ))}
    </div>
  ) : null
}

export default MinimizedModalsTray
